import { render, staticRenderFns } from "./FormDesignModel.vue?vue&type=template&id=be1b25bc&scoped=true"
import script from "./FormDesignModel.vue?vue&type=script&lang=js"
export * from "./FormDesignModel.vue?vue&type=script&lang=js"
import style0 from "./FormDesignModel.vue?vue&type=style&index=0&id=be1b25bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1b25bc",
  null
  
)

export default component.exports